/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "./generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OrgCustomFontFragment = {
  readonly __typename: "OrgCustomFont";
  readonly id: c.OrgCustomFontId;
  readonly name: string;
  readonly fontDescriptor: c.OrgCustomFontDescriptor;
};

export type OrgPublishedAppThemeQueryFragment = {
  readonly __typename: "OrgPublishedAppTheme";
  readonly id: c.OrgPublishedAppThemeId;
  readonly name: string;
  readonly styles: c.OrgPublishedAppThemeStyle;
  readonly colorPalette: {
    readonly __typename: "ColorPalette";
    readonly id: c.ColorPaletteId;
    readonly colors: ReadonlyArray<c.Color>;
    readonly name: string;
  } | null;
  readonly font: {
    readonly __typename: "OrgCustomFont";
    readonly id: c.OrgCustomFontId;
    readonly name: string;
    readonly fontDescriptor: c.OrgCustomFontDescriptor;
  } | null;
};

export type GetHexVersionQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  version: Types.Scalars["HexVersionString"]["input"];
}>;

export type GetHexVersionQuery = {
  readonly __typename: "Query";
  readonly hexVersionByNumber: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly appTheme: Types.AppTheme;
    readonly customPublishedAppTheme: {
      readonly __typename: "OrgPublishedAppTheme";
      readonly id: c.OrgPublishedAppThemeId;
      readonly name: string;
      readonly styles: c.OrgPublishedAppThemeStyle;
      readonly colorPalette: {
        readonly __typename: "ColorPalette";
        readonly id: c.ColorPaletteId;
        readonly colors: ReadonlyArray<c.Color>;
        readonly name: string;
      } | null;
      readonly font: {
        readonly __typename: "OrgCustomFont";
        readonly id: c.OrgCustomFontId;
        readonly name: string;
        readonly fontDescriptor: c.OrgCustomFontDescriptor;
      } | null;
    } | null;
  };
};

export const OrgCustomFontFragmentDoc = /*#__PURE__*/ gql`
  fragment OrgCustomFontFragment on OrgCustomFont {
    id
    name
    fontDescriptor
  }
`;
export const OrgPublishedAppThemeQueryFragmentDoc = /*#__PURE__*/ gql`
  fragment OrgPublishedAppThemeQueryFragment on OrgPublishedAppTheme {
    id
    name
    colorPalette {
      id
      colors
      name
    }
    font {
      id
      ...OrgCustomFontFragment
    }
    styles
  }
  ${OrgCustomFontFragmentDoc}
`;
export const GetHexVersionDocument = /*#__PURE__*/ gql`
  query GetHexVersion($hexId: HexId!, $version: HexVersionString!) {
    hexVersionByNumber(hexId: $hexId, version: $version) {
      id
      appTheme
      customPublishedAppTheme {
        id
        ...OrgPublishedAppThemeQueryFragment
      }
    }
  }
  ${OrgPublishedAppThemeQueryFragmentDoc}
`;

/**
 * __useGetHexVersionQuery__
 *
 * To run a query within a React component, call `useGetHexVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHexVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHexVersionQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetHexVersionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHexVersionQuery,
    GetHexVersionQueryVariables
  > &
    (
      | { variables: GetHexVersionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHexVersionQuery, GetHexVersionQueryVariables>(
    GetHexVersionDocument,
    options,
  );
}
export function useGetHexVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHexVersionQuery,
    GetHexVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHexVersionQuery, GetHexVersionQueryVariables>(
    GetHexVersionDocument,
    options,
  );
}
export function useGetHexVersionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHexVersionQuery,
    GetHexVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHexVersionQuery,
    GetHexVersionQueryVariables
  >(GetHexVersionDocument, options);
}
export type GetHexVersionQueryHookResult = ReturnType<
  typeof useGetHexVersionQuery
>;
export type GetHexVersionLazyQueryHookResult = ReturnType<
  typeof useGetHexVersionLazyQuery
>;
export type GetHexVersionSuspenseQueryHookResult = ReturnType<
  typeof useGetHexVersionSuspenseQuery
>;
export type GetHexVersionQueryResult = Apollo.QueryResult<
  GetHexVersionQuery,
  GetHexVersionQueryVariables
>;
